import AbstractValidator from './AbstractValidator';

export default class ExplodeValidator extends AbstractValidator
{
    run()
    {
        // TODO SPA: requires some rebuild @ \Portuna\Helper\Form\Filter to get this working(?)
        // should call the other Validators - testable with multi select // see RsvpFilter
        // currently the serverside validation is enough, this is just an placeholder to get the damn validation-icon
        return;
    }
}